import React, { useState } from 'react';
import { FaWallet, FaMobileAlt, FaCreditCard } from 'react-icons/fa';
import ConfirmPayment from './ConfirmPayment'; // Import the ConfirmPayment component
import { Link } from 'react-router-dom';
import { IoMdArrowRoundBack } from 'react-icons/io'; // Import the back arrow icon

function FillField() {
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage the modal
  const [isContentBlurred, setIsContentBlurred] = useState(false); // State for background blur
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(''); // State for selected payment method

  const handleVerifyPayClick = () => {
    setIsModalOpen(true); // Open the modal
    setIsContentBlurred(true); // Apply blur to the background
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
    setIsContentBlurred(false); // Remove blur from the background
  };

  const handleProceed = () => {
    // Proceed with the payment logic (can be routed to a new page or API call)
    setIsModalOpen(false); // Close the modal after proceeding
    setIsContentBlurred(false); // Remove blur from the background
  };

  const handlePaymentMethodClick = (method) => {
    setSelectedPaymentMethod(method); // Set the selected payment method
  };

  return (
    <>
      {/* Back Button Outside of Main Content */}
      <Link to={'/walk-in/form'}>
        <button className="absolute mt-2 top-16 left-3 p-2 text-black hover:text-gray-300 font-semibold text-2xl z-10">
          <IoMdArrowRoundBack />
        </button>
      </Link>

      <div className="w-full h-screen bg-white relative">
        {/* Background Content */}
        <div className={`w-full h-full ${isContentBlurred ? 'blur-sm' : ''}`}>
          {/* Payment Section */}
          <div className="max-w-5xl mx-auto mt-9 p-6 bg-white rounded-md shadow-sm">
            <div className="bg-gray-200 text-black p-3 mb-6 rounded-md">
              <h2 className="text-xl font-semibold">Enter Card Details</h2>
            </div>

            <div className="flex flex-col sm:flex-row gap-6">
              {/* Payment Methods */}
              <div className="w-full sm:w-1/3">
                <div className="bg-white rounded shadow-md divide-y divide-gray-300">
                  <button
                    className={`py-5 px-4 w-full text-left font-medium flex items-center gap-4 transition-all ${
                      selectedPaymentMethod === 'UPI' ? 'bg-gray-200' : 'hover:bg-gray-200'
                    }`}
                    onClick={() => handlePaymentMethodClick('UPI')}
                  >
                    <FaMobileAlt />
                    <Link to="/upi-payment">UPI</Link>
                  </button>
                  <button
                    className={`py-5 px-4 w-full text-left font-medium flex items-center gap-4 transition-all ${
                      selectedPaymentMethod === 'Credit/Debit/ATM Cards'
                        ? 'bg-gray-200'
                        : 'hover:bg-gray-200'
                    }`}
                    onClick={() => handlePaymentMethodClick('Credit/Debit/ATM Cards')}
                  >
                    <FaCreditCard />
                    <Link to="/card-payment">Credit/Debit/ATM Cards</Link>
                  </button>
                  <button
                    className={`py-5 px-4 w-full text-left font-medium flex items-center gap-4 transition-all ${
                      selectedPaymentMethod === 'Wallets' ? 'bg-gray-200' : 'hover:bg-gray-200'
                    }`}
                    onClick={() => handlePaymentMethodClick('Wallets')}
                  >
                    <FaWallet />
                    <Link to="/cash">Cash</Link>
                  </button>
                </div>
              </div>

              {/* Card Details Section */}
              <div className="w-full sm:w-2/3 bg-white p-4 shadow-md">
                <h2 className="text-md font-bold mb-4">Credit/Debit Card Details</h2>
                <div className="space-y-4">
                  <div>
                    <label
                      htmlFor="cardNumber"
                      className="block text-md font-medium text-gray-700 mb-2"
                    >
                      Enter Your Card No.
                    </label>
                    <input
                      type="text"
                      id="cardNumber"
                      className="border rounded border-gray-300 w-full p-3"
                      placeholder="XXXX-XXXX-XXXX-XXXX"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="cardHolderName"
                      className="block text-md font-medium text-gray-700 mb-2"
                    >
                      Enter Card Holder Name
                    </label>
                    <input
                      type="text"
                      id="cardHolderName"
                      className="border rounded border-gray-300 w-full p-3"
                      placeholder="Card Holder Name"
                    />
                  </div>

                  <div className="flex gap-4">
                    <div className="w-1/3">
                      <label
                        htmlFor="expiryMonth"
                        className="block text-md font-medium text-gray-700 mb-2"
                      >
                        Expiry Date
                      </label>
                      <select
                        id="expiryMonth"
                        className="border rounded border-gray-300 w-full p-3"
                      >
                        <option>Month</option>
                        {[...Array(12)].map((_, i) => (
                          <option key={i} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="w-1/3">
                      <label
                        htmlFor="expiryYear"
                        className="block text-md font-medium text-gray-700 mb-2"
                      >
                        &nbsp;
                      </label>
                      <select id="expiryYear" className="border rounded border-gray-300 w-full p-3">
                        <option>Year</option>
                        {[...Array(15)].map((_, i) => (
                          <option key={i} value={2024 + i}>
                            {2024 + i}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="w-1/3">
                      <label htmlFor="cvv" className="block text-md font-medium text-gray-700 mb-2">
                        CVV
                      </label>
                      <input
                        type="text"
                        id="cvv"
                        className="border rounded border-gray-300 w-full p-3"
                        placeholder="XXX"
                      />
                    </div>
                  </div>

                  <div className="flex items-center">
                    <input type="checkbox" id="saveCard" className="mr-2" />
                    <label htmlFor="saveCard" className="text-md font-medium text-gray-700">
                      Save card for future use
                    </label>
                  </div>

                  <div className="mt-6 text-right">
                    <button
                      className="bg-green-500 text-white py-3 w-full rounded shadow-md hover:text-black transition-all"
                      onClick={handleVerifyPayClick}
                    >
                      Verify & Pay
                    </button>
                  </div>

                  <div className="mt-4 text-sm text-center text-gray-600">
                    <p>
                      By continuing, you agree to the{' '}
                      <a href="/rules" className="text-blue-500 hover:underline">
                        Rules
                      </a>
                      ,{' '}
                      <a href="/privacy-policy" className="text-blue-500 hover:underline">
                        Privacy Policy
                      </a>
                      ,{' '}
                      <a href="/user-agreement" className="text-blue-500 hover:underline">
                        User Agreement
                      </a>{' '}
                      and{' '}
                      <a href="/terms-conditions" className="text-blue-500 hover:underline">
                        Terms & Conditions
                      </a>{' '}
                      of Trip.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ConfirmPayment Modal */}
        {isModalOpen && (
          <ConfirmPayment
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            paymentMethod={selectedPaymentMethod} // Pass selected payment method here
            onProceed={handleProceed}
          />
        )}
      </div>
    </>
  );
}

export default FillField;
